import {Component} from "react";

export default class FilterSwatch extends Component<any, any> {
  constructor(props: any) {
    super(props);

    // Get size parameter from URL
    const urlParams = new URLSearchParams(window.location.search);
    const size = urlParams.get('size');

    if (size) {
      if (size.includes(this.props.value)) {
        this.state = {
          checked: true
        }
      }
    }
  }

  state = {
    checked: false
  }

  handleCheckboxChange = (e: any) => {
    let value = e.target.getAttribute('value');
    let checked = e.target.getAttribute('data-checked') != 'true';

    if (checked) {
      if (this.props.name === 'taille') {
        window.addSizeFilter(value);
      } else if (this.props.name === 'marque') {
        window.addBrandFilter(value);
      }
    } else {
      if (this.props.name === 'taille') {
        window.removeSizeFilter(value);
      } else if (this.props.name === 'marque') {
        window.removeBrandFilter(value);
      }
    }

    this.setState({checked});
  }

  render() {
    return(
      <div className={'filter-swatch'}>
        <button
          data-checked={this.state.checked}
          id={`${this.props.name}-${this.props.dataKey}`}
          name={this.props.name}
          value={this.props.value}
          onClick={(e) => this.handleCheckboxChange(e)}
        >
          {this.props.value}
        </button>
      </div>
    )
  }
}
